import { FC, ReactNode } from 'react';
import { Form, InputProps } from 'antd';
import TimeRangeCustom from 'components/TimeRangeCustom';
import { convertHrsMinsToMins } from 'utils/string.utils';

interface FieldTimeRangeCustomProps {
  label: ReactNode;
  name: string;
  className?: string;
  style?: React.CSSProperties;
  disabled?: boolean;
  onBlur?: InputProps['onBlur'];
  planInput?: boolean;
}

const FieldTimeRangeCustom: FC<FieldTimeRangeCustomProps> = ({
  label,
  name,
  className,
  style,
  disabled,
  planInput = false,
  onBlur
}) => {
  return (
    <Form.Item
      label={label}
      name={name}
      className={className}
      rules={[
        {
          validator(_, value) {
            if (!value) {
              return Promise.resolve();
            }

            const [hourMin, hourMax] = value.split('-');
            const min = hourMin ? convertHrsMinsToMins(hourMin) : 0;
            const max = hourMax ? convertHrsMinsToMins(hourMax) : 0;
            return min <= max ? Promise.resolve() : Promise.reject(new Error('Max time should be bigger than min time'));
          },
        },
      ]}
      style={style}
    >
      <TimeRangeCustom onBlur={onBlur} disabled={disabled} planInput={planInput} />
    </Form.Item>
  );
};

export default FieldTimeRangeCustom;
